import { mount } from 'svelte';
import App from './App.svelte';
import './app.css';
import { theme } from './components/theme-state.svelte';
import { toasts } from './components/toast-queue.svelte';
import { initTelemetry } from './lib/telemetry';
import { appProgress as progress } from './routes/drill/app-progress';
import { noticeMessage } from './routes/drill/progress-view.svelte';

// 計測は mount の前に同期的に始める（observability.md §4。初期化前の例外と navigation を落とさない）。
initTelemetry();

// 描画前にテーマを付ける（保存値 → OS。?theme= は確認用の一時上書き）。
// 最初の描画のちらつきは public/theme-init.js が <head> で先に防ぐ。
theme.init();

// 進捗を読み込む（progress-store.md §1.1）。壊れた値・新しい版は mount の後に一度だけ知らせる。
const notices = progress.load();

// 別タブで書き換えられたら読み直す（後に書いた方が勝つ）。
window.addEventListener('storage', (e) => {
  for (const n of progress.handleStorageEvent(e.key)) toasts.show(noticeMessage(n));
});

// 保存を消されにくくする。結果は問わない（§1.1）。
void navigator.storage?.persist?.().catch(() => undefined);

const target = document.getElementById('app');
if (!target) {
  throw new Error('#app が見つかりません');
}

const app = mount(App, { target });
for (const n of notices) toasts.show(noticeMessage(n));

export default app;
